import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M8 9C8 8.44771 7.55228 8 7 8C6.44772 8 6 8.44771 6 9V13C6 13.5523 6.44771 14 7 14C7.55228 14 8 13.5523 8 13V9Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M11 8C11.5523 8 12 8.44771 12 9V13C12 13.5523 11.5523 14 11 14C10.4477 14 10 13.5523 10 13V9C10 8.44771 10.4477 8 11 8Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 3C5 1.34315 6.34315 0 8 0H10C11.6569 0 13 1.34315 13 3H17C17.5523 3 18 3.44772 18 4C18 4.55228 17.5523 5 17 5H16.9356L16.1222 17.1996C16.0172 18.7754 14.7083 20 13.1289 20H4.87111C3.29171 20 1.98281 18.7755 1.87775 17.1996L1.06445 5H1C0.447715 5 0 4.55228 0 4C0 3.44772 0.447715 3 1 3H5ZM7 3C7 2.44772 7.44772 2 8 2H10C10.5523 2 11 2.44772 11 3H7ZM3.06889 5H14.9311L14.1267 17.0665C14.0917 17.5918 13.6554 18 13.1289 18H4.87111C4.34464 18 3.90834 17.5918 3.87332 17.0665L3.06889 5Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}